<template>
    <div>
        <!-- State Youth: back navigation -->
        <div class="section pt-1 pb-0" v-if="isStateYouth && (screen === 'zones' || (screen === 'units' && backDistrictId))">
            <button type="button" class="btn btn-sm btn-outline-secondary" @click="goBackInHierarchy">
                <ion-icon name="arrow-back-outline" class="me-1"></ion-icon>
                <span v-if="screen === 'zones'">ജില്ലാ ലിസ്റ്റിലേക്ക്</span>
                <span v-else>മണ്ഡലം ലിസ്റ്റിലേക്ക്</span>
            </button>
        </div>

        <!-- Header Card -->
        <div class="section pt-1" :class="{ 'pt-0': isStateYouth && (screen === 'zones' || (screen === 'units' && backDistrictId)) }">
            <div class="wallet-card">
                <div class="balance">
                    <div class="left">
                        <span class="title mal-text">{{ headerTitleMal }}</span>
                        <h1 class="total text-primary">{{ headerTotal }}</h1>
                    </div>
                    <div class="right">
                        <ion-icon :name="headerIcon" style="font-size: 40px; color: #1a418c;"></ion-icon>
                    </div>
                </div>
            </div>
        </div>

        <!-- Search (district / zone pickers) -->
        <div class="section pt-0 mt-0 mb-1" v-if="screen === 'districts' || screen === 'zones'">
            <div class="search-form">
                <div class="input-wrapper">
                    <ion-icon name="search-outline"></ion-icon>
                    <input type="search" class="form-control" v-model="pickerSearch"
                        :placeholder="screen === 'districts' ? 'Search district...' : 'Search zone...'" />
                </div>
            </div>
        </div>

        <!-- Search + filters (unit / member view only) -->
        <template v-if="screen === 'units'">
            <div class="section pt-0 mt-0 mb-1">
                <div class="search-form">
                    <div class="input-wrapper">
                        <ion-icon name="search-outline"></ion-icon>
                        <input type="search" class="form-control" placeholder="Search by name or mobile..."
                            v-model="search" @input="onSearchInput" />
                    </div>
                </div>
            </div>

            <div class="section inset mt-1 mb-1" v-if="!loading">
                <div class="accordion" id="accordionProfFilter">
                    <div class="accordion-item">
                        <h2 class="accordion-header">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#profFilterBody" aria-expanded="false">
                                <ion-icon name="filter-outline" class="me-1"></ion-icon>
                                Filter
                                <span v-if="hasActiveFilters" class="badge badge-primary ms-2" style="font-size:10px;">Active</span>
                            </button>
                        </h2>
                        <div id="profFilterBody" class="accordion-collapse collapse" :class="hasActiveFilters ? 'show' : ''"
                            data-bs-parent="#accordionProfFilter">
                            <div class="accordion-body" style="padding: 10px !important;">
                                <div class="form-group">
                                    <div class="input-wrapper">
                                        <label class="label">Unit</label>
                                        <select class="form-control custom-select" v-model="filters.unit_id"
                                            @change="loadList">
                                            <option value="">---All Units---</option>
                                            <option v-for="u in unitsList" :key="u.unit_id" :value="u.unit_id">
                                                {{ u.unit_name }} ({{ u.count }})
                                            </option>
                                        </select>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="input-wrapper">
                                        <label class="label">Gender</label>
                                        <select class="form-control custom-select" v-model="filters.gender"
                                            @change="loadList">
                                            <option value="">---All---</option>
                                            <option value="Male">Male</option>
                                            <option value="Female">Female</option>
                                        </select>
                                    </div>
                                </div>
                                <button class="btn btn-sm btn-secondary mt-1" @click="clearFilters">
                                    <ion-icon name="close-outline"></ion-icon> Clear Filters
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </template>

        <!-- Page subtitle -->
        <div class="section pt-0 mt-0">
            <div class="listed-detail mt-1 page-title">
                <h3 class="text-center mt-1 mal-text custom-title">{{ pageSubtitleMal }}</h3>
            </div>
        </div>

        <!-- Loading -->
        <div class="section" v-if="loading">
            <div class="text-center py-4">
                <div class="spinner-border text-primary" role="status"></div>
                <p class="mt-2 mal-text">Loading...</p>
            </div>
        </div>

        <!-- District list (state) -->
        <div class="section mt-1" v-if="!loading && screen === 'districts' && filteredDistricts.length > 0">
            <div class="transactions" style="border-radius: 8px; overflow: hidden; border: 1px solid #e0e8f5;">
                <div class="item district-row" v-for="d in filteredDistricts" :key="'d-' + d.id" @click="openDistrict(d)">
                    <div class="detail">
                        <ion-icon name="location-outline" style="font-size: 28px; color: #1a418c;"></ion-icon>
                        <div>
                            <strong>{{ d.name }}</strong>
                            <p class="mb-0 text-muted" style="font-size: 12px;">{{ d.professional_count }} professionals</p>
                        </div>
                    </div>
                    <div class="right">
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                    </div>
                </div>
            </div>
        </div>

        <!-- Zone list (state) -->
        <div class="section mt-1" v-if="!loading && screen === 'zones' && filteredZones.length > 0">
            <div class="transactions" style="border-radius: 8px; overflow: hidden; border: 1px solid #e0e8f5;">
                <div class="item district-row" v-for="z in filteredZones" :key="'z-' + z.id" @click="openZone(z)">
                    <div class="detail">
                        <ion-icon name="git-network-outline" style="font-size: 28px; color: #1a418c;"></ion-icon>
                        <div>
                            <strong>{{ z.name }}</strong>
                            <p class="mb-0 text-muted" style="font-size: 12px;">{{ z.professional_count }} professionals</p>
                        </div>
                    </div>
                    <div class="right">
                        <ion-icon name="chevron-forward-outline"></ion-icon>
                    </div>
                </div>
            </div>
        </div>

        <!-- Empty district / zone pickers -->
        <div class="section" v-if="!loading && (screen === 'districts' || screen === 'zones') && listPickerEmpty">
            <div class="text-center py-4">
                <ion-icon name="folder-open-outline" style="font-size: 48px; color: #6c757d;"></ion-icon>
                <p class="mt-2 text-muted">No results.</p>
            </div>
        </div>

        <!-- Unit-wise list -->
        <div class="section" v-if="!loading && screen === 'units' && filteredUnits.length === 0">
            <div class="text-center py-4">
                <ion-icon name="people-outline" style="font-size: 48px; color: #6c757d;"></ion-icon>
                <p class="mt-2 text-muted">No professional members found.</p>
            </div>
        </div>

        <div v-if="!loading && screen === 'units' && filteredUnits.length > 0">
            <div v-for="unit in filteredUnits" :key="unit.unit_id" class="section mt-1">
                <div class="unit-header" @click="toggleUnit(unit.unit_id)">
                    <div class="unit-header-left">
                        <ion-icon name="business-outline" class="me-1"></ion-icon>
                        <span class="unit-name">{{ unit.unit_name }}</span>
                    </div>
                    <div class="unit-header-right">
                        <span class="badge badge-primary">{{ unit.members.length }}</span>
                        <ion-icon :name="expandedUnits[unit.unit_id] ? 'chevron-up-outline' : 'chevron-down-outline'"
                            class="ms-1"></ion-icon>
                    </div>
                </div>
                <div v-if="expandedUnits[unit.unit_id]" class="transactions">
                    <div class="item" v-for="(member, index) in unit.members" :key="member.id">
                        <div class="detail">
                            <img :src="member.gender === 'Female'
                                ? 'https://guide.msoftit.com/images/female-avatar.png'
                                : 'https://guide.msoftit.com/images/avatar-1.jpg'"
                                alt="img" class="image-block imaged w48" />
                            <div>
                                <strong>{{ index + 1 }}. {{ member.name }}</strong>
                                <p class="mb-0">
                                    <ion-icon name="call-outline"></ion-icon>
                                    <a :href="'tel:' + member.mobile" class="text-primary ms-1">{{ member.mobile }}</a>
                                </p>
                            </div>
                        </div>
                        <div class="right">
                            <span class="badge" :class="member.gender === 'Female' ? 'badge-danger' : 'badge-primary'">
                                {{ member.gender }}
                            </span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="section mt-1 mb-3" v-if="!loading && screen === 'units' && filteredUnits.length > 1">
            <div class="d-flex gap-2 justify-content-center">
                <button class="btn btn-sm btn-outline-primary" @click="expandAll">
                    <ion-icon name="expand-outline"></ion-icon> Expand All
                </button>
                <button class="btn btn-sm btn-outline-secondary" @click="collapseAll">
                    <ion-icon name="contract-outline"></ion-icon> Collapse All
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import UserService from "../services/user.service";

export default {
    name: "ProfessionalList",
    data() {
        return {
            loading: false,
            total: 0,
            allUnits: [],
            expandedUnits: {},
            search: '',
            searchTimeout: null,
            filters: {
                unit_id: '',
                gender: '',
            },
            // State hierarchy
            districtsList: [],
            zonesList: [],
            districtMetaName: '',
            pickerSearch: '',
        };
    },
    computed: {
        currentUser() {
            return this.$store.state.auth.user;
        },
        isStateYouth() {
            const u = this.currentUser;
            if (!u) return false;
            const lvl = parseInt(u.user_level, 10);
            return (lvl === 0 || lvl === 1) && parseInt(u.wing, 10) === 2;
        },
        routeSubLevel() {
            return parseInt(this.$route.params.sub_level, 10) || 0;
        },
        /** districts | zones | units */
        screen() {
            if (this.isStateYouth && this.routeSubLevel === 1) return 'districts';
            if (this.isStateYouth && this.routeSubLevel === 2) return 'zones';
            if (this.routeSubLevel === 3) return 'units';
            return 'units';
        },
        backDistrictId() {
            const q = this.$route.query && this.$route.query.district_id;
            return q ? String(q) : '';
        },
        headerTitleMal() {
            if (this.screen === 'districts') return 'ജില്ലകൾ';
            if (this.screen === 'zones') return 'മണ്ഡലങ്ങൾ';
            return 'പ്രൊഫഷണൽ അംഗങ്ങൾ';
        },
        headerIcon() {
            if (this.screen === 'districts') return 'map-outline';
            if (this.screen === 'zones') return 'layers-outline';
            return 'briefcase-outline';
        },
        headerTotal() {
            if (this.screen === 'districts' || this.screen === 'zones') return this.total || 0;
            return this.total || 0;
        },
        pageSubtitleMal() {
            if (this.screen === 'districts') return 'ജില്ല തിരഞ്ഞെടുക്കുക';
            if (this.screen === 'zones') return (this.districtMetaName || '') + ' — മണ്ഡലം തിരഞ്ഞെടുക്കുക';
            return 'മണ്ഡലം - പ്രൊഫഷണൽ ലിസ്റ്റ്';
        },
        filteredDistricts() {
            if (!this.pickerSearch) return this.districtsList;
            const s = this.pickerSearch.toLowerCase();
            return this.districtsList.filter(d => String(d.name).toLowerCase().includes(s));
        },
        filteredZones() {
            if (!this.pickerSearch) return this.zonesList;
            const s = this.pickerSearch.toLowerCase();
            return this.zonesList.filter(z => String(z.name).toLowerCase().includes(s));
        },
        listPickerEmpty() {
            if (this.screen === 'districts') return this.filteredDistricts.length === 0;
            if (this.screen === 'zones') return this.filteredZones.length === 0;
            return false;
        },
        hasActiveFilters() {
            return this.filters.unit_id || this.filters.gender || this.search;
        },
        unitsList() {
            return this.allUnits;
        },
        filteredUnits() {
            let units = this.allUnits;
            if (this.filters.unit_id) {
                units = units.filter(u => u.unit_id == this.filters.unit_id);
            }
            if (this.filters.gender || this.search) {
                const genderFilter = this.filters.gender;
                const searchLower = this.search ? this.search.toLowerCase() : '';
                units = units.map(unit => {
                    let members = unit.members;
                    if (genderFilter) {
                        members = members.filter(m => m.gender === genderFilter);
                    }
                    if (searchLower) {
                        members = members.filter(m =>
                            m.name.toLowerCase().includes(searchLower) ||
                            String(m.mobile).includes(searchLower)
                        );
                    }
                    return { ...unit, members };
                }).filter(unit => unit.members.length > 0);
            }
            return units;
        },
    },
    watch: {
        '$route'() {
            this.pickerSearch = '';
            this.resolveAndLoad();
            this.setPageTitle();
        },
    },
    mounted() {
        if (!this.currentUser) {
            location.replace('/');
            return;
        }
        this.setPageTitle();
        this.resolveAndLoad();
    },
    methods: {
        setPageTitle() {
            let t = 'Professional List';
            if (this.isStateYouth && this.routeSubLevel === 1) t = 'Professional List — Districts';
            else if (this.isStateYouth && this.routeSubLevel === 2) t = 'Professional List — Zones';
            this.$root.updateParent(t);
        },
        resolveAndLoad() {
            if (this.screen === 'districts') {
                this.loadDistricts();
            } else if (this.screen === 'zones') {
                this.loadZones();
            } else {
                this.loadList();
            }
        },
        goBackInHierarchy() {
            if (this.screen === 'zones') {
                this.$router.push({ path: '/org/1/0/professional-list' });
            } else if (this.screen === 'units' && this.backDistrictId) {
                this.$router.push({ path: '/org/2/' + this.backDistrictId + '/professional-list' });
            } else {
                this.$router.go(-1);
            }
        },
        openDistrict(d) {
            this.$router.push({ path: '/org/2/' + d.id + '/professional-list' });
        },
        openZone(z) {
            const districtId = this.$route.params.id;
            this.$router.push({
                path: '/org/3/' + z.id + '/professional-list',
                query: districtId ? { district_id: String(districtId) } : {},
            });
        },
        loadDistricts() {
            this.loading = true;
            this.districtsList = [];
            this.zonesList = [];
            this.allUnits = [];
            UserService.authGetRequest('org-professional-list?level=districts').then(
                (res) => {
                    if (res.data.status === 'success' && res.data.view === 'districts') {
                        this.districtsList = res.data.districts || [];
                        this.total = res.data.total_professionals || 0;
                    } else {
                        this.districtsList = [];
                        this.total = 0;
                    }
                    this.loading = false;
                },
                () => {
                    this.districtsList = [];
                    this.total = 0;
                    this.loading = false;
                }
            );
        },
        loadZones() {
            const districtId = this.$route.params.id;
            this.loading = true;
            this.zonesList = [];
            this.allUnits = [];
            UserService.authGetRequest(
                'org-professional-list?level=zones&district_id=' + encodeURIComponent(districtId)
            ).then(
                (res) => {
                    if (res.data.status === 'success' && res.data.view === 'zones') {
                        this.zonesList = res.data.zones || [];
                        this.districtMetaName = res.data.district_name || '';
                        this.total = res.data.total_professionals || 0;
                    } else {
                        this.zonesList = [];
                        this.districtMetaName = '';
                        this.total = 0;
                    }
                    this.loading = false;
                },
                () => {
                    this.zonesList = [];
                    this.districtMetaName = '';
                    this.total = 0;
                    this.loading = false;
                }
            );
        },
        onSearchInput() {
            clearTimeout(this.searchTimeout);
            this.searchTimeout = setTimeout(() => {
                this.autoExpandIfSingleUnit();
            }, 300);
        },
        clearFilters() {
            this.search = '';
            this.filters = { unit_id: '', gender: '' };
        },
        toggleUnit(unitId) {
            this.expandedUnits = {
                ...this.expandedUnits,
                [unitId]: !this.expandedUnits[unitId],
            };
        },
        expandAll() {
            const expanded = {};
            this.filteredUnits.forEach(u => { expanded[u.unit_id] = true; });
            this.expandedUnits = expanded;
        },
        collapseAll() {
            this.expandedUnits = {};
        },
        autoExpandIfSingleUnit() {
            if (this.filteredUnits.length === 1) {
                this.expandedUnits = { [this.filteredUnits[0].unit_id]: true };
            }
        },
        loadList() {
            this.loading = true;
            const params = [];
            const routeZoneId = this.$route.params.id;
            if (routeZoneId !== undefined && routeZoneId !== null && routeZoneId !== '') {
                params.push('zone_id=' + encodeURIComponent(routeZoneId));
            }
            if (this.filters.unit_id) {
                params.push('unit_id=' + encodeURIComponent(this.filters.unit_id));
            }
            if (this.filters.gender) {
                params.push('gender=' + encodeURIComponent(this.filters.gender));
            }
            const query = params.length ? ('?' + params.join('&')) : '';

            UserService.authGetRequest('org-professional-list' + query).then(
                (response) => {
                    if (response.data.status === 'success' && (!response.data.view || response.data.view === 'units')) {
                        this.total = response.data.total || 0;
                        this.allUnits = response.data.units || [];
                        if (this.allUnits.length === 1) {
                            this.expandedUnits = { [this.allUnits[0].unit_id]: true };
                        }
                    } else {
                        this.allUnits = [];
                        this.total = 0;
                    }
                    this.loading = false;
                },
                () => {
                    this.allUnits = [];
                    this.total = 0;
                    this.loading = false;
                }
            );
        },
    },
};
</script>

<style scoped>
.district-row {
    cursor: pointer;
}

.district-row:active {
    background: #f0f4fa;
}

.transactions .item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 14px;
    border-bottom: 1px solid #f0f0f0;
}

.transactions .item .detail {
    display: flex;
    align-items: center;
    gap: 10px;
    flex: 1;
}

.transactions .item .detail > div {
    flex: 1;
}

.transactions .item .right {
    min-width: 40px;
    text-align: right;
}

.unit-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #1a418c;
    color: #fff;
    padding: 10px 14px;
    border-radius: 8px 8px 0 0;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
}

.unit-header-left {
    display: flex;
    align-items: center;
    gap: 6px;
}

.unit-header-right {
    display: flex;
    align-items: center;
    gap: 6px;
}

.unit-name {
    font-size: 14px;
}

.transactions .item {
    background: #fff;
}

.transactions .item:last-child {
    border-bottom: none;
}

.transactions .item .detail {
    gap: 10px;
}

.transactions .item .right {
    min-width: 64px;
    text-align: right;
}

.search-form .input-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.search-form .input-wrapper ion-icon {
    position: absolute;
    left: 10px;
    font-size: 18px;
    color: #6c757d;
}

.search-form .input-wrapper input {
    padding-left: 36px;
}
</style>
